<template>
	<div>
		<div class="my-3">
			<router-link to="/" class="no-underline text-white text-lg"><< Back</router-link>
		</div>
		<div class="scoreboard" :class="resultClass">
			<div class="badge" id="user" :class="resultClass">user</div>
			<div class="badge" id="computer" :class="resultClass">comp</div>
			<span v-model="userScore" v-text="userScore"></span> :
			<span v-model="computerScore" v-text="computerScore"></span>
		</div>
		<div class="result">
			<h2 v-text="message"></h2>
		</div>
		<div class="playground">
			<div class="participant" id="user">
				<h3>Your Choice</h3>
				<img :src="userChoiceImage" id="userChoice" :class="[userChoice, resultClass]" class="rps-img" alt="Image of a hand playing rock, paper, scissors">
			</div>
			<div class="participant" id="computer">
				<h3>My Choice</h3>
				<img :src="computerChoiceImage" id="computerChoice" :class="[computerChoice, resultClass]" class="rps-img" alt="Image of a hand playing rock, paper, scissors">
			</div>
		</div>
		<p class="message">Make your choice</p>
		<div class="choices">
			<div class="choice" @click="game('rock')">
				<img src="/img/rock.png" alt="Drawing of a hand forming a rock">
			</div>
			<div class="choice" @click="game('paper')">
				<img src="/img/paper.png" alt="Drawing of a hand forming paper">
			</div>
			<div class="choice" @click="game('scissors')">
				<img src="/img/scissors.png" alt="Drawing of a hand forming scissors">
			</div>
		</div>
		<div class="buttons">
			<button class="reset" @click="resetScores">Reset Score</button>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				computerChoice: '',
				computerScore: 0,
				message: "Let's play Rock Paper Scissors!",
				userChoice: 'rock',
				userScore: 0,
				winner: 'none'
			}
		},
		methods: {
			game(userChoice) {
				this.userChoice = userChoice;
				this.computerChoice = this.getComputerChoice();

			 	if (this.userChoice.localeCompare(this.computerChoice) === 0) return this.draw();

			 	if (this.userChoice === 'rock') {
			 		switch (this.computerChoice) {
			 			case 'paper':
			 				return this.loss('Paper covers rock');
						case 'scissors':
							return this.win('Rock break scissors');
					}
			 	}
			 	if (this.userChoice === 'paper') {
			 		switch (this.computerChoice) {
			 			case 'rock':
			 				return this.win('Paper covers rock');
						case 'scissors':
							return this.loss('Scissors cut paper');
			 		}
			 	}
			 	if (this.userChoice === 'scissors') {
			 		switch (this.computerChoice) {
			 			case 'rock':
			 				return this.loss('Rock breaks scissors');
						case 'paper':
							return this.win('Scissors cut paper');
			 		}
			 	}
			},
			getComputerChoice() {
				let validChoices = ['rock', 'paper', 'scissors'];

				let randomInteger = Math.floor(
					Math.random() * 3
				);

				return validChoices[randomInteger];
			},
			resetScores() {
				this.message = "Okay let's start over.";
				this.computerScore = 0;
				this.userScore = 0;
			},
			win(outcome) {
				this.message = `${outcome}. You win!`;
				this.userScore++;
				this.winner = 'user';
			},
			loss(outcome) {
				this.message = `${outcome}. I win!`;
				this.computerScore++;
				this.winner = 'computer';
			},
			draw() {
				this.message = "It's a draw."
				this.winner = 'none';
			}
		},
		computed: {
			computerChoiceImage() {
				return `/img/${this.computerChoice}.png`;
			},
			userChoiceImage() {
				return `/img/${this.userChoice}.png`;
			},
			resultClass() {
				if (this.userScore == 0 && this.computerScore == 0) return '';
				if (this.winner == 'user') return 'win';
				if (this.winner == 'computer') return 'loss';
			}
		},
		created() {
			this.computerChoice = this.getComputerChoice();
		}
	}
</script>

<style lang="scss" scoped>
	.rps-img {
		height: 125px;
		width: 125px;
	}
	.playground {
		border-bottom: 3px solid #404552;
		display: flex;
		justify-content: center;
		margin: 35px auto;
		width: 90%;

		img {
			margin: 15px 25px 25px;
		}

		h3 {
			color: #FFF;
			text-align: center;
		}

		.participant {
			display: flex;
			flex-direction: column;
		}
	}
	#user {
		img {
			transform: rotate(90deg);

			&#userChoice.paper,
			&#userChoice.scissors {
				-moz-transform: rotate(-90deg) scaleY(-1);
			    -webkit-transform: rotate(-90deg) scaleY(-1);
			    transform: rotate(-90deg) scaleY(-1);
	    		-o-transform: rotate(-90deg) scaleY(-1);
			}
			&.win {
				position: relative;
				animation: shake .5s linear 0s infinite;
			}
		}
	}
	#computer {
		img {
			-moz-transform: rotate(270deg) scaleX(-1);
		    -o-transform: rotate(270deg) scaleX(-1);
		    -webkit-transform: rotate(270deg) scaleX(-1);
		    transform: rotate(270deg) scaleX(-1);

		    &#computerChoice.paper,
		    &#computerChoice.scissors {
				transform: rotate(-90deg);
		    }
		    &.loss {
				position: relative;
				animation: shake .5s linear 0s infinite;
			}
		}
	}
	.choices {
		display: flex;
		justify-content: center;
		margin: 50px;
	}
	.choice {
		border-radius: 50%;
		border: 2px solid #FFF;
		cursor: pointer;
		margin: 0 20px;
		padding: 10px;
		transition: background-color .5s ease;
		
		img {
			height: 50px;
			width: 50px;	
		}
		
		&:hover {
			background-color: #1C1E24;
		}
	}
	.choice:active {
		box-shadow: inset 1px 1px 5px #404552;
		outline: none;
	}
	.scoreboard {
		border-radius: 5px;
		border: 3px solid #FFF;
		color: #FFF;
		font-size: 40px;
		margin: 0 auto;
		padding: 10px 15px;
		position: relative;
		text-align: center;
		width: 50%;
		
		&.win {
			border-color: #35C446;
		}
		
		&.loss {
			border-color: #E2584D;
		}
	}

	.badge {
		background-color: #E2584D;
		border-radius: 5px;
		font-size: 14px;
		padding: 2px 10px;
		position: absolute;
		top: 25px;
		
		&#user {
			left: -25px;
		}

		&#user.win, 
		&#computer.loss {
			background-color: #35C446;	
		}
		
		&#computer {
			right: -30px;
		}
	}

	.result  {
		h2 {
			color: #FFF;
			font-size: 1.75rem;
			margin-top: 25px;
			text-align: center;
		}
	}

	.message {
		color: #FFF;
		font-size: 1.25rem;
		font-weight: bold;
		text-align: center;
	}
	@keyframes shake {
		0% {
			top: 0px;
			left: 0px;
		}
		25% {
			top: -3px;
			left: 3px;
		}
		50% {
			top: 0;
			left: 0;
		}
		75% {
			top: -3px;
			left: 3px;
		}
		100% {
			top: 0;
			left: 0;
		}
	}	
	@media screen and (min-width: 368px) {
		.scoreboard {
			max-width: 35%;
		}
	}

	@media screen and (min-width: 460px) {
		.rps-img {
			height: 125px;
			width: 125px;
		}

		.playground {
			img {
				margin: 25px 45px 45px;
			}
		}

		.scoreboard {
			padding: 15px 20px;
			max-width: 25%;
		}
	}

</style>
